import { FC } from 'react';

import { Article, Heading, Slider } from '@/components';

import { BlogPostDocument } from '@/types';
import classNames from 'classnames';
import styles from './relatedpost.module.scss';

const RelatedPosts: FC<IRelatedPosts> = ({ articlesList }) => {
  const breakpoints = {
    640: {
      spaceBetween: 32,
    },
  };

  if (!articlesList?.length) {
    return null;
  }

  return (
    <section
      className={classNames(
        styles.blog_article__related_post,
        'blog_article__related_post',
      )}
    >
      <Slider
        breakpoints={breakpoints}
        className={styles.blog_article__related_post_carousel}
        showSliderButtons
        showSliderHeader
        sliderHeading={<Heading level={2}>Related Post</Heading>}
        spaceBetween={16}
      >
        {articlesList?.map(item => (
          <Article
            article={item}
            classCss={styles.blog_article__related_post_article}
            key={item.id}
          />
        ))}
      </Slider>
    </section>
  );
};

interface IRelatedPosts {
  articlesList: BlogPostDocument[];
}

export { RelatedPosts };
